/* eslint-disable import/prefer-default-export */
import { isEmpty } from 'lodash'
import * as React from 'react'
import { CSSSelector } from '@src/utils/css.selector.helper'
import { useEffect } from 'react'
import useForceUpdate from '@src/hooks/use-force-update.hook'
import { State } from '../models/internal.state'

export type HeaderProps<T> = {
  title: string
  update: any
  state: State<T>
  searchValue?: string
  showCount: boolean
  count: () => number
  className: string
}

const HeaderCSSSelectors = {
  title: new CSSSelector('gridTitle'),
  count: new CSSSelector('gridCount')
}

function Header<T>(props: HeaderProps<T>) {
  const { update, title, state, showCount, count, className, searchValue } =
    props
  const countText = count()
  const titleValue = isEmpty(searchValue) ? title : `${title} found`

  const forceUpdate = useForceUpdate()

  useEffect(() => {
    forceUpdate()
  }, [update, state])

  return (
    <h2 data-role={'data-grid-header'} className={className}>
      {title && (
        <span className={HeaderCSSSelectors.title.value}>{titleValue}</span>
      )}
      {showCount && (
        <>
          {title && <span style={{ marginRight: '3px' }}>:</span>}
          <span className={HeaderCSSSelectors.count.value}>{countText}</span>
        </>
      )}
    </h2>
  )
}

export default React.memo(Header)
